import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children, allowedRoles }) => {
  const access = localStorage.getItem("accessToken");
  const role = localStorage.getItem("userRole");
  const location = useLocation();


console.log("TOKEN:", localStorage.getItem("accessToken"));
console.log("ROLE:", localStorage.getItem("userRole"));



  // 🔒 No token → kill access immediately
  if (!access) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // 🔒 Role not allowed
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
